<template>
  <div ref="course" class="course-home">
    <course-header
      :layout-type="layoutType"
      :first-campus="campusObj"
      :is-show-cart="isShowCart"
      :grade-code="gradeCode+''"
      :grade-str="gradeStr"
      :cart-num="cartNum"
      :grade-list="gradeList"
      @styleChange="updateLayout"
      @changeSchool="changeSchool"
      @parentBottom="parentBottom"
      @changeGrade="changeGrade" />
    <van-pull-refresh :class="{'no-banner-pull':banners.length===0}" :head-height="97" v-model="refreshing" @refresh="onRefresh">
      <template #loosing>
        <img :src="gifImg" class="doge" >
        <div class="loading-tip">
          <p>下拉可以刷新</p>
          <p>最后更新：{{ courseHomeRefreshTime }}</p>
        </div>
      </template>
      <van-overlay :show="isPageLoading">
        <van-loading class="n-loading" size="24px" vertical>加载中...</van-loading>
      </van-overlay>
      <div v-if="!isPageLoading" :class="[{'p-short-top':banners.length===0&&xsid!==''},{'p-long-top':banners.length===0&&xsid===''},{'min-top':productType.length > 0}]">
        <div v-if="banners.length > 0" :class="{'short-swiper':xsid}" class="swiper">
          <van-swipe :autoplay="5000" class="c-swipe" indicator-color="white">
            <van-swipe-item v-for="item in banners" :key="item.id" @click="toThird(item.url)">
              <img :src="item.pic" alt="">
            </van-swipe-item>
          </van-swipe>
        </div>
        <grid-swiper v-if="kingkongList.length" :data="kingkongList"/>
        <course-list v-if="!isPageLoading" ref="courseList" :layout="layoutType" :reload="reload" :xsid="localXsid" :loading="loading" :grade-code="gradeCode+''" @changeLoading="changeLoading" />
      </div>
    </van-pull-refresh>
    <school-area-select :is-simple-api="isCampusLoading" :show-school-select="showSchoolSelect" :school-list="frontCartCampusList" @close-school-pop="closeSchoolPop" @school-select="onSchoolSelect" />
    <van-popup v-model="showActive" :close-on-click-overlay="false" class="activity" position="center">
      <div class="pop-img" @click="toThird(pUrl)">
        <img :src="pimg" alt="">
      </div>
    </van-popup>
    <van-icon v-show="showActive" class="close-activity" name="close" @click="closeImg" />
  </div>
</template>

<script>
import { getNowTime } from '@/utils/util';
import { getToken } from '@/utils/auth';
import { Swipe, SwipeItem, Tab, Tabs, Popup, Icon, Overlay, Loading, PullRefresh, Toast, Grid, GridItem } from 'vant';
import courseHeader from '@/components/Header/course';
import schoolAreaSelect from '@/components/course/school-area-select';
import courseList from '@/components/course/course';
import GridSwiper from './components/grid-swiper.vue';
import { getKingkongList } from '../../../api/course';
const LAYOUT_TYPE_KEY = 'layout-type';
export default {
  name: 'CourseIndex',
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading,
    [PullRefresh.name]: PullRefresh,
    courseHeader,
    courseList,
    schoolAreaSelect,
    GridSwiper
  },
  data() {
    return {
      active: 0,
      chooseId: 0,
      showActive: false,
      gradeCode: undefined,
      gradeStr: '',
      gradeList: [],
      productType: [],
      deptId: '',
      loading: false,
      isPageLoading: true,
      banners: [],
      popImg: [],
      pimg: '',
      popActive: 0,
      cartNum: 0,
      isShowCart: false,
      pUrl: '',
      from: '',
      isRefreshPage: false,
      refreshing: false,
      courseHomeRefreshTime: localStorage.getItem('courseHomeRefreshTime') || '',
      gifImg: require('@/assets/img/course/pic_refresh.gif'),
      showSchoolSelect: false,
      frontCartCampusList: [],
      campusObj: {},
      xsid: this.$route.query.code || '',
      localXsid: '',
      empty_img: require('@/assets/img/empty_course.png'),
      reload: false,
      isCampusLoading: false,
      layoutType: undefined,
      kingkongList: []
    };
  },
  beforeRouteEnter(to, from, next) {
    // 如果刷新或者刚登录 显示弹出框
    let fromList = ['/code-login', '/login', '/reset-psw', '/register', '/certification/staff', '/certification/student', '/'];
    next(vm => {
      vm.from = from.path;
      if (fromList.indexOf(from.path) > -1) {
        vm.getDialog();
      }
    });
  },
  /**
   * 跳转其余页面将isRefreshPage设置为false
   * 跳转回本页面不刷新
   */
  beforeRouteLeave(to, from, next) {
    this.isRefreshPage = false;
    next();
  },
  watch: {
    chooseId(val, oldval) {
      if (val !== oldval) {
        this.loading = true;
      }
    },
    showSchoolSelect(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.btn_pos);
    this.isRefreshPage = false;
  },
  async created() {
    // 更新 上次刷新时间
    let saveTime = getNowTime().substring(5, 16);
    localStorage.setItem('courseHomeRefreshTime', saveTime);
    this.courseHomeRefreshTime = saveTime;
    this.layoutType = localStorage.getItem(LAYOUT_TYPE_KEY) || 'normal';
    await this.getReData();
  },
  mounted() {
    window.addEventListener('scroll', this.btn_pos);
  },
  activated() {
    console.log('this.isRefreshPage', this.isRefreshPage);
    if (!this.isRefreshPage) {
      this.getBanner('category');
      if (getToken()) {
        this.isShowCart = true;
        this.getCartCount();
        if (this.gradeCode === 'undefined' || localStorage.getItem('isLoginPage') === true) {
          this.getDefaultDetails();
        }
      } else {
        if (this.gradeCode === 'undefined' || this.from.indexOf('/login') > -1) {
          this.gradeStr = '全部年级';
          this.getGradeCode();
        }
      }
    }
  },
  methods: {
    getKingkongList() {
      getKingkongList().then(res => {
        this.kingkongList = res.data;
      });
    },
    updateLayout() {
      if (this.layoutType === 'normal') {
        this.layoutType = 'grid';
      } else {
        this.layoutType = 'normal';
      }
      localStorage.setItem(LAYOUT_TYPE_KEY, this.layoutType);
    },
    btn_pos() {
      var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      if (this.banners.length > 0) {
        if (scrollTop >= 179) {
          // this.$refs.typeTab.$el.style.position = 'fixed';
          // this.$refs.typeTab.$el.style.top = this.pxTovw(79) + 'px';
          // this.$refs.typeTab.$el.style.width = '100%';
          // this.$refs.typeTab.$el.style.zIndex = '666';
          this.$refs.courseList.$el.style.paddingTop = this.pxTovw(54) + 'px';
        } else {
          // this.$refs.typeTab.$el.style.position = 'relative';
          // this.$refs.typeTab.$el.style.top = 'auto';
          // this.$refs.typeTab.$el.style.width = '100%';
          this.$refs.courseList.$el.style.paddingTop = this.pxTovw(15) + 'px';
        }
      }
    },
    async getReData(type) {
      this.isRefreshPage = true;
      console.log('this.xsid', this.xsid);
      console.log('local', localStorage.getItem('xsid'));
      console.log('type', type);
      this.localXsid = localStorage.getItem('xsid') + '';
      if (!this.xsid) {
        if (localStorage.getItem('frontCartCampusList')) {
          let frontCartCampusList = JSON.parse(localStorage.getItem('frontCartCampusList'));
          frontCartCampusList.forEach(item => {
            if (~~item.id === ~~localStorage.getItem('xsid')) {
              item.isChosed = true;
            } else {
              item.isChosed = false;
            }
          });
          this.frontCartCampusList = frontCartCampusList;
          if (type !== 're') {
            this.campusObj = this.frontCartCampusList[0];
          }
        }
      }
      this.getKingkongList();
      await this.getBanner();
      await this.getGradeList();
      // await this.getProductType();
      if (type !== 're') {
        if (getToken()) {
          this.isShowCart = true;
          await this.getCartCount();
          await this.getDefaultDetails();
        } else {
          console.log(77777);
          this.gradeStr = '全部年级';
          await this.getGradeCode();
          if (this.$refs.courseList) {
            this.$refs.courseList.getList();
          }
        }
      }
      this.isPageLoading = false;
      // if (type === 're') {
      //   setTimeout(() => {
      //     this.$nextTick(() => {
      //       if (this.$refs.courseList) {
      //         this.loading = true;
      //         this.$refs.courseList.getList();
      //       }
      //     });
      //   }, 500);
      // }
    },
    // 获取校区列表
    async getCampusList() {
      this.isCampusLoading = true;
      this.frontCartCampusList = [];
      await this.$store.dispatch('GetCampusList').then(res => {
        if (res.code === 200) {
          let frontCartCampusList = res.data;
          frontCartCampusList.unshift({
            campusId: '',
            campusName: '全部校区',
            campusType: '1',
            id: ''
          });
          this.frontCartCampusList = frontCartCampusList;
          console.log(frontCartCampusList);
          if (frontCartCampusList.length > 0) {
            let campusid = localStorage.getItem('xsid') || '';
            console.log('campusid', campusid);
            let hasCampus = false;
            this.frontCartCampusList.forEach(item => {
              if (~~item.id === ~~campusid) {
                hasCampus = true;
                item.isChosed = true;
              }
            });
            console.log(this.frontCartCampusList);
            console.log('hasCampus', hasCampus);
            if (!hasCampus) {
              Toast('校区不存在，即将跳转至主网校');
              localStorage.setItem('frontCartCampusList', JSON.stringify(this.frontCartCampusList));
              localStorage.setItem('xsid', '');
              setTimeout(() => {
                location.href = '/';
              }, 2000);
            }
          }
        }
        this.isCampusLoading = false;
      }).catch(() => {
        this.isCampusLoading = false;
      });
    },
    onRefresh() {
      console.log('on refresh');
      this.refreshing = false;
      this.loading = true;
      this.urlTogetCampusCode();
      this.getBanner('category');
      this.getKingkongList();
      if (getToken()) {
        this.getCartCount();
      }
      setTimeout(() => {
        this.loading = false;
        let saveTime = getNowTime().substring(5, 16);
        this.$nextTick(() => {
          if (this.$refs.courseList) {
            this.loading = true;
            this.$refs.courseList.getList();
          }
        });
        localStorage.setItem('courseHomeRefreshTime', saveTime);
        this.courseHomeRefreshTime = saveTime;
      }, 500);
    },
    // 弹出框
    async getDialog() {
      this.$store.dispatch('GetBanner', { type: 3, tag: 'H5' }).then(res => {
        if (res.code === 200) {
          if (res.data.length > 0) {
            this.popImg = res.data;
            this.pimg = this.popImg[0].pic;
            this.pUrl = this.popImg[0].url;
            this.showActive = true;
          }
        }
      }).catch(() => {
        this.popImg = [];
      });
    },
    async changeSchool(data) {
      this.showSchoolSelect = data;
      await this.getCampusList();
    },
    async onSchoolSelect(item, index) {
      this.campusObj = item;
      localStorage.setItem('xsid', item.id);
      this.showSchoolSelect = false;
      this.isPageLoading = true;
      this.chooseId = 0;
      this.active = 0;
      await this.getReData('re');
    },
    closeSchoolPop() {
      this.showSchoolSelect = false;
    },
    // 轮播图
    async getBanner(type) {
      this.$store.dispatch('GetBanner', { type: 1, tag: 'H5' }).then(async(res) => {
        if (res.code === 200) {
          this.banners = res.data || [];
          // this.banners = [];
          if (type === undefined) {
            // await this.getProductType();
          }
        }
      }).catch(async() => {
        this.banners = [];
        if (type === undefined) {
          // / await this.getProductType();
        }
      });
    },
    // 年级列表
    async getGradeList() {
      await this.$store.dispatch('getGradeList').then(res => {
        if (res.code === 200) {
          this.gradeList = res.data.rows;
        }
      });
    },
    // 基本信息
    async getDefaultDetails() {
      await this.$store.dispatch('GetDefaultUser').then(res => {
        if (res.code === 200 && res.data.length > 0) {
          this.gradeStr = res.data[0].gradeInfoStr || '全部年级';
          this.gradeCode = Number(res.data[0].gradeInfo) || 0;
          this.deptId = res.data[0].deptId || '';
          localStorage.setItem('isLoginPage', false);
          if (this.gradeCode === 0) {
            this.getGradeCode();
          }
        } else {
          this.gradeStr = '全部年级';
          this.getGradeCode();
        }
        this.$nextTick(() => {
          if (this.$refs.courseList) {
            this.loading = true;
            console.log('getDefaultDetails  111');
            this.$refs.courseList.getList();
          }
        });
      }).catch(() => {
        this.gradeStr = '全部年级';
        this.getGradeCode();
      });
    },
    // 类别
    async getProductType() {
      await this.$store.dispatch('GetProductType').then(res => {
        this.isPageLoading = false;
        if (res.code === 200) {
          this.productType = res.data;
          if (this.productType.length > 0) {
            if (this.chooseId === 0) {
              this.chooseId = this.productType[0].id;
              console.log('chooseId', this.chooseId);
            }
          } else {
            this.reload = true;
            this.chooseId = 0;
          }
        }
      }).catch(() => {
        this.isPageLoading = false;
      });
    },
    // 默认的年级code
    getGradeCode() {
      console.log('this.gradeList', this.gradeList);
      console.log('this.gradeCode  old ', this.gradeCode);
      console.log('this.gradeStr', this.gradeStr);
      if (this.gradeList.length > 0) {
        this.gradeList.forEach(item => {
          if (item.rows.length > 0) {
            item.rows.forEach(ele => {
              if (ele.gradeName === this.gradeStr) {
                this.gradeCode = ele.gradeCode;
                console.log('this.gradeCode  new ', this.gradeCode);
              }
            });
          }
        });
      }
    },
    // 修改分类id
    changeTab() {
      this.chooseId = this.productType[this.active].id;
      this.$nextTick(() => {
        if (this.$refs.courseList) {
          this.loading = true;
          console.log('changeTab');
          this.$refs.courseList.getList();
        }
      });
    },
    // 切换年级
    changeGrade(obj) {
      this.gradeCode = obj.gradeCode;
      this.gradeStr = obj.gradeName;
      this.$nextTick(() => {
        if (this.$refs.courseList) {
          this.loading = true;
          console.log('changeGrade');
          this.$refs.courseList.getList();
        }
      });
    },
    // 跳转第三方url
    toThird(url) {
      if (url) {
        window.open(url);
      }
    },
    // 切换loading状态
    changeLoading(loading) {
      this.loading = loading;
    },
    // 广告弹出框 点x
    closeImg() {
      this.showActive = false;
      if (this.popActive < this.popImg.length - 1) {
        this.popActive += 1;
        this.pimg = this.popImg[this.popActive].pic;
        this.pUrl = this.popImg[this.popActive].url;
        this.showActive = true;
      } else {
        this.showActive = false;
      }
    },
    // 购物车数量
    async getCartCount() {
      await this.$store.dispatch('GetCartCount').then(res => {
        if (res.code === 200) {
          this.cartNum = Number(res.data);
        }
      });
    },
    /**
     * 使底部tabbar的z-index小于年级列表的弹出框
     */
    parentBottom(data) {
      if (data) {
        this.$refs.course.classList.add('no-bottom');
      } else {
        this.$refs.course.classList.remove('no-bottom');
      }
    }
  }
};
</script>
<style scoped lang="scss">
.course-home {
  width: 100%;
  position: relative;
  padding-bottom: 100px;
  background: #f3f5f6;

  // >>> .van-sticky--fixed {
  //   z-index: 1003;
  // }

  .van-pull-refresh {
    /deep/ .van-pull-refresh__head {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;

      img {
        width: 72px;
      }
    }

    >>> .loading-tip {
      text-align: left;
      margin-left: 24px;

      p {
        font-size: 28px;
        color: #9f9f9f;
        height: 40px;
        line-height: 40px;
      }

      p:first-child {
        color: #1e1e1e;
      }
    }
  }

  .no-banner-pull {
    /deep/ .van-pull-refresh__head {
      height: 300px !important;
      padding-top: 200px;
    }
  }

  .swiper {
    padding: 30px;
    background: $white;
    margin-top: 158px;
  }

  .short-swiper {
    margin-top: 92px;
  }

  .c-swipe .van-swipe-item {
    color: $white;
    font-size: 40px;
    line-height: 300px;
    text-align: center;

    img {
      width: 100%;
      height: 100%;
    }
  }

  /deep/ .van-swipe {
    border-radius: 17px;
  }

  /deep/ .van-swipe__indicator {
    background-color: $white;
    opacity: 0.6;
    width: 10px;
    height: 10px;
  }

  /deep/ .van-swipe__indicator--active {
    width: 24px;
    height: 10px;
    border-radius: 5px;
    background-color: $blue !important;
  }

  // /deep/ .van-swipe__indicators {
  //   left: auto;
  //   right: 30px;
  // }

  /deep/ .van-tab {
    font-size: 30px;
    flex: none;
    padding: 0 20px 0 30px;
  }

  /deep/ .van-card {
    padding: 38px 30px;
    border-radius: 10px;
    // box-shadow: 0 4px 20px 0 rgba($dark-black, 0.1);
    box-shadow: 0 4px 20px 6px rgba($dark-black,0.1);
  }

  /deep/ .van-card:not(:first-child) {
    margin-top: 30px;
  }

  /deep/ .van-card__thumb {
    width: 240px;
    height: 134.4px;
    margin-right: 20px;

    .img {
      display: flex !important;
      align-items: center;
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  /deep/ .van-card__content {
    min-height: 88px;
  }

  /deep/ .van-card__title {
    font-size: 28px;
    line-height: 40px;
    max-height: 88px;
    color: rgba($dark-black, 0.65);
    font-weight: bold;
    margin-bottom: 18px;
  }

  /deep/ .van-card__price {
    color: $red;
    font-size: 32px;
  }

  /deep/ .van-card__num {
    height: 40px;
    font-size: 26px;
    color: rgba($dark-black, 0.25);
    display: flex;
    align-items: center;

    @extend %one-line-text-overflow;
  }

  .no-swipe {
    padding-top: 80px;
  }

  .has-swipe {
    padding-top: 0;
  }
}

.no-bottom {
  height: 100%;
  bottom: 0;
  z-index: 9999;
}

/deep/ .van-popup--center {
  top: 318px;
  transform: translate3d(-50%, -160px, 0);
}

.activity {
  z-index: 2004;
  height: 800px;
  width: 630px;
  border-radius: 20px;
  border: 2px solid #979797;

  .pop-img {
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.close-activity {
  position: absolute;
  color: $white;
  z-index: 4000;
  font-size: 52px;
  top: 1000px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 52px;
  height: 52px;
}

.p-short-top {
  padding-top: 92px;
}

.p-long-top {
  padding-top: 158px;
}

/deep/ .van-swipe {
  width: 100%;
  height: 292px;
}

/deep/ .n-loading {
  padding-top: 20vh;
}

/deep/ .van-overlay {
  z-index: 10002;
}

/deep/ .fixed-short-tab {
  position: fixed;
  top: 92px;
  width: 100%;
  z-index: 666;

  & + .course-list {
    padding-top: 108px;
  }
}

/deep/ .fixed-long-tab {
  position: fixed;
  top: 158px;
  width: 100%;
  z-index: 666;

  & + .course-list {
    padding-top: 108px;
    min-height: calc(100vh - 266px);
  }
}

.empty_course {
  text-align: center;

  img {
    width: 500px;
    height: 320px;
    margin-top: 50px;
  }

  p {
    color: #b0b0b0;
    font-size: 28px;
  }
}

>>> .van-tabs__wrap {
  overflow-x: auto;
  background: $white;

  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
}

.min-top {
  min-height: calc(100vh - 260px);
}
</style>
<style>
.van-toast {
  z-index: 20001 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/course/home/index.vue